import { DecoratedGroup } from '@/features-slice/group/GroupSlice';
import { useDecoratedGroupPoller } from '@/hooks/useDecoratedGroup';
import { useState } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

interface Props {
  parentGroup: DecoratedGroup;
  level: number;
  onSelect: (uuid: string) => void;
  selectedUuid: string;
  inverted?: boolean;
}

const fontSizesMap = {
  0: 'text-lg',
  1: 'text-base',
  2: 'text-sm',
  3: 'text-xs',
};

const chevronSizesMap = {
  0: 14,
  1: 12,
  2: 10,
  3: 8,
};

export const GroupHierarchy = (p: Props) => {
  const { parentGroup, onSelect, selectedUuid, level, inverted = false } = p;
  const [expanded, setExpanded] = useState(level === 0);
  const onExpand = () => {
    onSelect(parentGroup.uuid);
    setExpanded((exp) => !exp);
  };
  const parentUuid = parentGroup.uuid;
  const selected = parentUuid === selectedUuid;
  const { decoratedGroup: dParentGroup, loading } = useDecoratedGroupPoller(
    parentUuid,
    selectedUuid === parentUuid ? 30000 : null // 30s, TODO arbitrary
  );
  const childGroups = dParentGroup?.children;
  const title = `${parentGroup.name}`;

  const selectedTextColor = inverted ? 'text-black' : 'text-white';

  return (
    <div className="w-full px-2 mb-1">
      <div
        className="flex flex-row items-center text-neutral-500 cursor-pointer hover:text-neutral-400 justify-start"
        onClick={() => onSelect(parentUuid)}
      >
        <div onClick={onExpand} className="mr-1">
          <ChevronIcon
            loading={loading}
            size={chevronSizesMap[level]}
            expanded={expanded}
            selected={selected}
          />
        </div>
        <h5
          className={`${fontSizesMap[level]} 
        text-opacity-90 cursor-pointer ${
          selected
            ? 'font-bold ' + selectedTextColor
            : 'cursor-default hover:text-neutral-400 font-semibold text-neutral-500'
        }`}
        >
          {title}
        </h5>
        {/* <FaPlus size="12" className="my-auto ml-auto text-accent text-opacity-80" /> */}
      </div>
      {expanded &&
        childGroups &&
        childGroups.map((childGroup, _) => (
          <GroupHierarchy
            inverted={inverted}
            key={childGroup.uuid}
            level={level + 1}
            onSelect={onSelect}
            selectedUuid={selectedUuid}
            parentGroup={childGroup}
          />
        ))}
    </div>
  );
};

const ChevronIcon = ({ loading, expanded, selected, size = 14, selectedTextColor }: any) => {
  const chevClass = `text-accent ${loading ? 'text-opacity-40' : 'text-opacity-80'} my-auto mr-1 ${
    selected ? selectedTextColor : ''
  }`;
  return expanded ? (
    <FaChevronDown size={size} className={chevClass} />
  ) : (
    <FaChevronRight size={size} className={chevClass} />
  );
};
